var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMyaccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1701.954 57.45c-.652-.623-1.908-1.733-3.158-2.324-1.03-.487-1.621-.98-1.805-1.507-.127-.366-.07-.785.174-1.281.185-.375.36-.686.521-.973.68-1.216 1.206-2.093 1.206-5.2 0-4.651-2.685-4.886-3.216-4.886-.435 0-.707.096-.97.189-.289.103-.587.208-1.266.22-1.23.02-3.804.063-3.804 4.34 0 2.993.78 4.367 1.392 5.472.156.283.304.55.421.817.521 1.182.141 2.008-1.197 2.599-1.691.747-2.488 1.136-4.149 2.597-1.862-1.957-3.012-4.598-3.012-7.513 0-6.025 4.884-10.91 10.909-10.91s10.91 4.885 10.91 10.91c0 2.884-1.128 5.5-2.956 7.45M1694 60.91c-2.716 0-5.194-1-7.103-2.641 1.47-1.286 2.172-1.638 3.795-2.355 1.88-.83 2.52-2.302 1.756-4.038-.138-.311-.298-.6-.466-.905-.58-1.046-1.255-2.232-1.255-4.942 0-3.206 1.522-3.23 2.73-3.25.858-.016 1.277-.163 1.613-.282.224-.08.36-.127.606-.127 1.01 0 2.125.997 2.125 3.795 0 2.822-.423 3.516-1.067 4.666-.17.302-.353.63-.547 1.024-.376.762-.451 1.476-.226 2.123.289.829 1.042 1.507 2.368 2.135 1.087.513 2.227 1.517 2.84 2.097-1.919 1.676-4.422 2.7-7.169 2.7m0-22.91c-6.627 0-12 5.372-12 12 0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.628-5.373-12-12-12",
    transform: "translate(-1682.000000, -38.000000)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMyaccount);
export default __webpack_public_path__ + "static/media/ico-myaccount.0ac764fe.svg";
export { ForwardRef as ReactComponent };